import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lv5_7_1",
  "use": "icon-lv5_7_1-usage",
  "viewBox": "0 0 56 80",
  "content": "<symbol viewBox=\"0 0 56 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lv5_7_1\">\r\n<rect width=\"56\" height=\"80\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol